import React from "react";
import ReactDOM from "react-dom/client";
import AppProvider from "./app";

// Suppress verbose chakra warnings.
// eslint-disable-next-line no-console
console.warn = () => {};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<AppProvider />);
